import React from "react";
import {
  SortedCompanionSections,
  SectionTypes,
} from "@beable/content-types";
import { AssignedSectionDTO } from "@beable/roster-backend-client-v1";
import {
  Typography,
  Grid,
} from "@mui/material";
import { upperFirst } from "lodash";

interface UserSectionDataProps {
  assignedSections?: AssignedSectionDTO[];
}

export default function UserSectionData({
  assignedSections,
}: UserSectionDataProps) {
  return (
    <Grid size={12}>
      {assignedSections ? (
        assignedSections.map((section) => (
          <Typography key={section.sectionTypeCode}>
            {upperFirst(section.sectionTypeCode)}
            {SortedCompanionSections.includes(
              section.sectionTypeCode as SectionTypes
            )
              ? "*"
              : ""}
          </Typography>
        ))
      ) : (
        <Typography>No sections assigned</Typography>
      )}
      <Typography variant="caption">* Denotes companion section</Typography>
    </Grid>
  );
}
